// REACT
import * as React from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';

// VENDOR COMPONENTS
import FlatButton from 'material-ui/FlatButton';
import ArrowLeft from 'material-ui/svg-icons/hardware/keyboard-arrow-left';

// CUSTOM COMPONENTS
import { StretchCard } from 'components';
import { ModuleList } from '../ModuleList';
import ServiceCardOuterDiv from './ServiceCardOuterDiv';

// UTILS

class ServiceCard extends React.Component/*<ComponentProps, {}>*/ {
    
    constructor(props) {
        super(props);
        this.state = {
            loginDialogOpen: false,
            showConfirmGetMaple: false,
            showIcons: false,
        }
    }
    componentDidMount() {
        setTimeout(()=>{
            this.props.getServiceModules(this.props.service._id);
            this.setState({
                showIcons: true
            });
        }, 1500)
    }

    render(){
        const { service, provider, company, serviceModules } = this.props;
        return (
            <ServiceCardOuterDiv ref="ServiceCardOuterDiv" id="ServiceCardOuterDiv"  style={{ marginBottom: 25,}}>
                <StretchCard
                    key={service._id}
                    cardImageHeight={275}
                    linkURL={`/service/detail/${service._id}`}
                    backgroundImageURL={service.coverPhotoURL}
                    avatarURL={provider.profilePhotoURL}
                    logoURL={company.logoURL}
                    // typeTitleText={service.type} // not used in card right now
                    mainTitleText={service.name}
                    cardOverlayPrice={`$${service.price/100}`}
                    subTitleText={`${provider.name && provider.name.first} ${provider.name && provider.name.last} | ${provider.designation}`}
                    fontSizeDivider={1.1}
                    marginBottom={15}
                />
                <div style={{ height: 25,}} >
                { this.props.serviceModules[service && service._id] && this.props.serviceModules[service && service._id].length > 0 && this.state.showIcons &&
                    <ModuleList
                        serviceModules={[...this.props.serviceModules[this.props.service._id]]}
                        styles={{ display: 'flex', flexDirection: 'row' }}
                        height={25}
                    />
                } 
                </div>
                
            </ServiceCardOuterDiv>
        );
    }
}

const mapStateToProps = ({ payment, service, client, auth }) => {
    return {
        credits: payment.credits,
        loginDialogOpen: auth.loginDialogOpen,
        serviceModules: service.customModules,
        userData: client.clientData,
    };
};
export default connect(mapStateToProps, actions)(ServiceCard);


// WEBPACK FOOTER //
// ./src/js/components/ServiceCard/ServiceCard.jsx